export default __webpack_public_path__ + "static/media/coming_soon_bg.6b05eb8f.png";